import { render, staticRenderFns } from "./p07.vue?vue&type=template&id=fa1e0e94&scoped=true&"
import script from "./p07.vue?vue&type=script&lang=js&"
export * from "./p07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1e0e94",
  null
  
)

export default component.exports